import { render, staticRenderFns } from "./ListItems.vue?vue&type=template&id=4ef42a20&scoped=true"
import script from "./ListItems.vue?vue&type=script&lang=js"
export * from "./ListItems.vue?vue&type=script&lang=js"
import style0 from "./ListItems.vue?vue&type=style&index=0&id=4ef42a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef42a20",
  null
  
)

export default component.exports